import { download } from 'thirdweb/storage'
import { thirdwebClient } from '../api-clients/thirdweb'
import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query'

type UseIpfsQueryOptions<T> = Omit<
  UndefinedInitialDataOptions<T | null>,
  'queryFn' | 'queryKey'
>

const useIpfs = <T>(
  uri: string | undefined,
  options?: UseIpfsQueryOptions<T>
) => {
  return useQuery({
    queryFn: async () => {
      const data = await download({
        client: thirdwebClient,
        uri: uri!,
      })
      const parsedData = data.json()
      return parsedData
    },
    enabled: Boolean(uri && options?.enabled),
    queryKey: ['ipfs', uri],
    ...options,
  })
}

export default useIpfs
